import { COMMANDERS } from './../../../c.managers/LevelManager/store.d'
import { Object3D } from 'three'
import { Battle } from '../../../d.controllers/BattleController'
import { Characters } from '../../../d.controllers/CharactersController'
import Interactive from './Interactive'
import { GAME_OBJECTS } from './types'

export default class Treasure extends Interactive {
  owner: COMMANDERS
  constructor(obj: Object3D) {
    super(obj)
    this.types.push(GAME_OBJECTS.TREASURE)
    this.owner = obj.userData.args.owner
    Battle.updateTresure(obj.userData.args.owner, obj.userData.args)
  }

  getsLooted(amount: number) {
    this.reserves -= amount
  }

  get reserves() {
    return Battle.getTresureState(this.owner)?.amount || 0
  }

  set reserves(amount: number) {
    Battle.updateTresure(this.owner, { amount: Math.max(0, amount) })
  }

  isSelectable() {
    return false
  }
}
